export * from './FileFormatTxtIcon';
export * from './FileFormatTxtIcon16Light';
export * from './FileFormatTxtIcon16Regular';
export * from './FileFormatTxtIcon16Solid';
export * from './FileFormatTxtIcon20Light';
export * from './FileFormatTxtIcon20Regular';
export * from './FileFormatTxtIcon20Solid';
export * from './FileFormatTxtIcon24Regular';
export * from './FileFormatTxtIcon24Solid';
export * from './FileFormatTxtIcon32Regular';
export * from './FileFormatTxtIcon64Regular';
